<template>
  <div class="ds-section">
    <div class="section-header">
      <h3>{{ title }}</h3>
      <span class="ds-example-button cat-pill default light">example</span>
    </div>
    <div class="ds-section-content">
      <slot></slot>
    </div>
  </div>
</template>

<script type="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DsSection",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
});
</script>
